import { Component, Container } from '@tencent/alloy-renderer';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { TableCellComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-cell-component-wrapper';
import { CANVAS_TABLE_CELL_CONTAINER_ID } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';

export class TableComponent extends Component {
    private model: ITableModel;
    private readonly factoryOptions: InterfaceFactoryOptions<ITableModel>;

    /**
     * 缓存Cell组件
     */
    private cacheMap: Map<string, TableCellComponentWrapper>;

    /**
     * 临时存储存在的key，用于对cacheMap进行清理
     */
    private existKeys: string[];

    public constructor(factoryOptions: InterfaceFactoryOptions<ITableModel>) {
        super();
        this.factoryOptions = factoryOptions;
        this.cacheMap = new Map();
        this.existKeys = [];
        this.id = CANVAS_TABLE_CELL_CONTAINER_ID;
    }

    public updateModel(model: ITableModel): void {
        this.model = model;
        this.updateComponent();
    }

    public dispose(): void {
        super.dispose();
        this.cacheMap.clear();
        this.existKeys = [];
    }

    public updateTextEditorCursor(cursor: string): void {
        // eslint-disable-next-line no-restricted-syntax
        for (const key of this.cacheMap.keys()) {
            const component = this.cacheMap.get(key) as TableCellComponentWrapper;
            component.updateTextEditorCursor(cursor);
        }
    }

    private updateComponent(): void {
        this.existKeys = [];
        this.model.tableItems.forEach((rowInfo) => {
            rowInfo.forEach((cell) => {
                if (!cell.hMerge && !cell.vMerge) {
                    const { key } = cell;
                    let component: TableCellComponentWrapper | undefined;
                    if (!this.cacheMap.has(key)) {
                        const cellComponent = new TableCellComponentWrapper(this.factoryOptions, cell);
                        this.cacheMap.set(key, cellComponent);
                        component = cellComponent;
                        this.addChild(cellComponent);
                    } else {
                        component = this.cacheMap.get(key) as TableCellComponentWrapper;
                    }
                    component.updateComponent(cell);
                    component.x = cell.props.style.left;
                    component.y = cell.props.style.top;
                    this.existKeys.push(key);
                }
            });
        });
        // 回收无用的缓存
        // eslint-disable-next-line no-restricted-syntax
        for (const key of this.cacheMap.keys()) {
            if (!this.existKeys.includes(key)) {
                const removed = this.cacheMap.get(key) as TableCellComponentWrapper;
                removed.dispose();
                this.removeChild(removed);
                this.cacheMap.delete(key);
            }
        }
    }
}
